import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../services/userService";
import { ResponseError } from "../../../objects/common/responseError";
import { ResetPasswordModel } from "../../../objects/users/resetPasswordModel";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'reset-password',
    templateUrl: './resetPassword.component.html',
    moduleId: module.id.toString()
})
export class ResetPasswordComponent implements OnInit {
    public model: ResetPasswordModel;
    public processing: boolean;
    public success: boolean;
    public errors: Array<ResponseError> = [];

    constructor(private userService: UserService, private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.model = new ResetPasswordModel();
        this.model.Id = this.route.snapshot.queryParams['userid'] || '';
        this.model.Code = this.route.snapshot.queryParams['token'] || '';
    }

    public forgotPassword(isValid: boolean): void {
        this.errors = [];

        if (!isValid)
            return;

        this.processing = true;
        this.userService.resetPassword(this.model).then(response => {
            this.processing = false;
            this.success = true;
        }).catch(response => {
            this.processing = false;
            this.errors = this.errors.concat(response.Errors);
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/auth/resetPassword/resetPassword.component.ts